import { Modal } from "react-bootstrap";
import CustomValuesHook from "../../Hooks/customValuesHook";
import { useEffect, useState } from "react";
import { changeState, toggleCustomerStatus } from "../../api/requestAxios/getDetectedSensitiveWordLog";
import { ErrorToast, InfoToast } from "../../shared";
import { CloseIcon } from "../../assets/images/svg/closeIcon";
import "./style.scss";
import { enToPersianChar } from "../../functions/extensions/enToPersianChar";

const ShowModalBlock = ({ states, getLog, setStates,customer}) => {

 

  const changeStatusFn = async () => {
    try {
      const response = await toggleCustomerStatus({'customerId':customer.Id});
      InfoToast("تغییرات با موفقیت انجام شد");
      setStates({ isShowModalBlock: false });

      getLog();
    } catch (error) {
      ErrorToast(error);
    }
  };

  const handleClose = () => {
    setStates({ isShowModalBlock: false });
  };
  return (
    <Modal
      show={states?.isShowModalBlock}
      onHide={handleClose}
      animation={true}
      dir="rtl"
      className="modal-status-activity"
    >
      <Modal.Header>
        <Modal.Title
          className="d-flex justify-content-between w-100"
          style={{ fontSize: "16px" }}
        >
          <div>
            { states?.logInfo?.isSuspended && !states?.logInfo?.isActive
              ? "درخواست رفع مسدودی"
              : "درخواست مسدود کردن"}
          </div>
          <span onClick={handleClose}>
            <CloseIcon />
          </span>
        </Modal.Title>
      </Modal.Header>
      <div className="modal-status-activity-content-view mt-3">
        {/* <div className="d-flex justify-content-start align-items-center">
          <label> شماره خط: </label>
          <span>
            {enToPersianChar(
              states?.logInfo?.customerLineNumber.replace("+98", "0")
            )}
          </span>
        </div> */}
        <div className="d-flex justify-content-start align-items-center">
          <label> نام مشترک: </label>
          <span>{customer?.FirstName}{' '}{customer?.LastName}</span>
        </div>
        <label>
          { states?.logInfo?.isSuspended && !states?.logInfo?.isActive
            ? "آیا از رفع مسدودی و نادیده گرفتن این مشترک مطمئن هستید؟"
            : "آیا از مسدود کردن این مشترک مطمئن هستید؟"}
        </label>
        <div className="d-flex justify-content-center align-items-center mt-3">
          <div className="d-flex justify-content-between align-items-center footer-wrpper">
            <button
              className="btn btn-primary"
              onClick={() => changeStatusFn()}
            >
              { states?.logInfo?.isSuspended && !states?.logInfo?.isActive? "بله" : "بله مسدود شود"}
            </button>
            <button className="btn btn-default" onClick={() => handleClose()}>
              انصراف
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default ShowModalBlock;
